<template>
  <div id="base-home">
    <!-- banner (features inside) -->
    <BannerSection />

    <!-- products -->
    <ProductsSection />
    <InfoSliderSection />
    <ArticleSection />
    <ThreeBannerSection />

    <!-- download app section -->
    <DownloadApp />

    <!-- award section -->
    <AwardSection />

    <ClientSection />
    <BottomSection />
  </div>
</template>

<script>
import mixinMetaInfo from "@/misc/mixinMetaInfo";
import mixinMobile from "@/misc/mixinMobile";
import BannerSection from "./section/banner-section.vue";
import DownloadApp from "./section/download-app-section.vue";
import AwardSection from "./section/award-section.vue";
import ProductsSection from "./section/products-section.vue";
import InfoSliderSection from "./section/info-slider/index.vue";
import ArticleSection from "./section/article/index.vue";
import ThreeBannerSection from "./section/three-banner/index.vue";
import ClientSection from "./section/client/index.vue";
import BottomSection from "./section/bottom-section.vue";

export default {
  name: 'HomePage',
  components: {
    BannerSection,
    DownloadApp,
    AwardSection,
    ProductsSection,
    InfoSliderSection,
    ArticleSection,
    ThreeBannerSection,
    ClientSection,
    BottomSection,
  },
  mixins: [mixinMetaInfo, mixinMobile],
  metaInfo() {
    return this.SEO({
      channel: 'channel',
      title: 'Lion Parcel Jasa Pengiriman Paket Kecil & Besar bisa COD Ongkir',
      description: this.metaInfo.meta_info_description,
      keywords: this.metaInfo.meta_info_keyword,
      publishedTime: this.metaInfo.meta_info_publish_time,
      image: this.metaInfo.attachment_meta_info_photo_url
    });
  },
  data() {
    return {
      searchMetaInfo: "_",
    }
  },
  computed: {},
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "style";
</style>
